import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React from 'react';
import { FDStack, FDTitleText } from '@facet-wealth/design';
import {
  InvestorEligibilityAlert,
} from 'Views/Page/Content/Templates/InvestorProfilePageTemplate/InvestorProfileSections/InvestorEligibilityAlert';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder } from 'Components/utils';

const useStyles = buildUseStyles('InvestorProfileViewLayout', (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& > * + *': {
      ...getBorder(theme, { top: true }),
    },
  },
}));

const InvestorProfileViewLayout = () => {
  const {
    resource,
  } = useMetaLayoutContext();
  const classes = useStyles();

  const sections = resource?.attr('sectionData')?.resources().list().map((sectionResource => (
    <FDStack direction="column" spacing={1} key={sectionResource.id()} paddingX={3} paddingY={2}>
      <FDTitleText value={sectionResource.attr('title')} />
      <span>{sectionResource.metaField('wasDiscussed').attr('prompt')} <strong>{sectionResource.attr('wasDiscussed')}</strong></span>
      <InvestorEligibilityAlert resource={sectionResource} />
    </FDStack>
  )

  ));

  return (
    <div className={classes.root}>
      {sections}
    </div>
  );
};

InvestorProfileViewLayout.defaultProps = {};

InvestorProfileViewLayout.propTypes = {};

export default InvestorProfileViewLayout;
